'use client';
import { AppBar, AppBarProps, SxProps, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useIsMobile from '../../../../utils/useIsMobile';
import useScroll from './useScroll';

type Props = AppBarProps & { isMobile?: boolean };

const CustomAppBar = ({
  isMobile: initIsMobile,
  sx: propsSx,
  ...props
}: Props) => {
  const isMobile = useIsMobile(initIsMobile);
  const { isTop } = useScroll();
  const theme = useTheme();
  const topSx: SxProps = {
    minHeight: isMobile ? 'auto' : 80,
    background: 'transparent',
  };

  const scrolledSx: SxProps = {
    minHeight: isMobile ? 'auto' : 64,
    background: theme.palette.background.default,
  };

  const [sx, setSx] = useState(topSx);

  useEffect(() => {
    const sx = { ...(isTop ? topSx : scrolledSx) };
    setSx(sx);
  }, [isTop]);

  const maxWidth = 2200;
  const maxWidthSx = maxWidth
    ? {
        maxWidth: maxWidth - 32,
        [`${theme.breakpoints.up(maxWidth)}`]: {
          mx: `calc((100vw - ${maxWidth}px) / 2 + 16px)`,
        },
      }
    : {};

  return (
    <AppBar
      sx={{
        ...maxWidthSx,
        transition: 'all 0.4s ease',
        my: 1,
        mx: { xs: 1, md: 2 },
        py: 0.5,
        boxSizing: 'border-box',
        width: `calc(100% - ${theme.spacing(isMobile ? 2 : 4)})`,
        borderRadius: 1,
        ...sx,
        ...(propsSx as Record<string, any>),
      }}
      {...props}
    />
  );
};

export default CustomAppBar;
